
export {Delete,
DeleteCommand,
Input,
InsertTextCommand,
TextTransformation,
TextWatcher,
TwoStepCaretMovement,
Typing,
TypingChangeBuffer,
_DeleteObserver,
findAttributeRange,
findAttributeRangeBound,
getLastTextLine,
inlineHighlight} from '../../../frontend-editor-ckeditor-web/__liferay__/exports/@ckeditor$ckeditor5-typing$dist$index.js.js';
